module.exports = __webpack_public_path__ + "img/bg-home-spaceman-and-dog.313ea5b0.svg";